<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <div class="protocol-header">
                <h1>智步云上模型网买家协议</h1>
            </div>
            <div class="protocol-content">
                <!-- 协议前言 -->
                <div class="protocol-section">
                    <p>感谢您（即在智步云上模型网进行购买操作的用户）选择智步云上模型网为您提供服务。《智步云上模型网买家协议》（以下简称“本协议”）由您和您所购买作品的出售者共同与北京智步云上科技有限公司（以下简称“我们”）签订。
                    </p>
                </div>

                <!-- 一、协议的确认 -->
                <div class="protocol-section">
                    <h2>一、协议的确认</h2>
                    <p>1.1您在使用智步云上模型网服务之前，应当认真阅读本协议，请您务必审慎阅读、充分理解本协议中相关条款内容，尤其是字体加粗部分、免除或者限制责任的条款、争议解决和法律适用条款。如您对本协议有任何疑问，您可通过智步云上模型网客服进行咨询，以便我们为您解释和说明。
                    </p>
                    <p>1.2当您按照购买页面提示填写信息，阅读并同意本协议或其他方式确认即表示您已充分阅读、理解并接受本协议的全部内容，并与智步云上模型网达成本协议。本协议内容包括协议正文及所有智步云上模型网已经发布的各类规则，所有规则与本协议正文具有同等法律效力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容主张本协议无效，或要求撤销本协议。如您不同意本协议，您应当立即停止购买操作。如果您在本协议生效前已成为智步云上模型网的购买方，即视为您表示同意接受本协议的全部内容，否则请您停止使用智步云上模型网的交易服务。
                    </p>
                    <p>1.3 智步云上模型网有权根据需要不时地制定、修改本协议或各类规则，如我们对本协议进行修改，我们将通过智步云上模型网（<span style="font-weight: bold; color: #E3E3E3;">http://swocs.com.cn/model/</span>）网站（如果将来我们变更网址或增加其他网址，请以届时的网址为准）予以公布，经修订的协议一经公布立即自动生效。若您无法同意变更修改后的协议内容，您有权停止使用相关服务，如您继续使用服务，则将视为您已接受经修订的条款。当您与智步云上模型网发生争议时，应以最新的条款为准，双方协商一致的，也可另行以书面形式变更相关服务和对应协议内容。
                    </p>
                    <p>1.4 智步云上模型网（<span style="font-weight: bold; color: #E3E3E3;">http://swocs.com.cn/model/</span>）是北京智步云上科技有限公司旗下运营的专业原创数字创意作品供应平台和定制服务平台。智步云上模型网作为原创数字创意作品网络服务平台，以诚信服务为宗旨，以便捷高效为目标，智步云上模型网不作为交易方，也不上传任何作品，仅为交易双方提供第三方网络平台服务。智步云上模型网提供的各项电子服务的所有权、经营管理权、运营权及最终解释权归北京智步云上科技有限公司所有。
                    </p>
                    <p>1.5本协议旨在促进开放、透明、分享、责任的商业规则，保障智步云上模型网用户的合法权益，创建、维护和谐的网络商业环境。</p>
                    <p>1.6您在使用智步云上模型网服务中的所有行为均应遵守国家法律、行政法规、部门规章等规范性文件以及与智步云上模型网签署的相关协议，不违背社会公共利益或者公共道德，不损害他人的合法权益，不违反本协议及相关规则与规定。
                    </p>
                </div>

                <!-- 二、协议范围 -->
                <div class="protocol-section">
                    <h2>二、协议范围</h2>
                    <p>2.1本协议由您和您所购买的作品的出售者共同与智步云上模型网（北京智步云上科技有限公司）缔结，本协议对您与智步云上模型网均具有约束力和合同效力。</p>
                    <p>2.2除另行明确声明外，本协议阐述之条款和条件适用于您使用智步云上模型网（以网站、客户端、小程序以及随技术发展出现的新形态）时我们向您提供的各项服务，同时任何使服务范围扩大或功能增强的新内容亦无条件地受本协议约束，包括新产品及新增的服务或功能。
                    </p>
                    <p>2.3本协议不涉及您与智步云上模型网其它用户之间因网上交易而产生的法律关系及法律纠纷。
                    </p>
                </div>

                <!-- 三、交易须知 -->
                <div class="protocol-section">
                    <h2>三、交易须知</h2>
                    <p>3.1 本平台模型素材为三维数字模型，是虚拟商品（非实体模型），其展示效果受软硬件环境影响，与现实环境中的真实物体存在差异。<span style="font-weight: bold; color: #E3E3E3;">模型素材一经购买，不支持任何形式的退款。</span></p>
                    <p>3.2 除非素材发布者另有特别说明，模型的结构、精度和细节等均以预览图和线框图所示内容为准。预览图未展示的部分默认视为未设计。如有疑问，请在购买前联系客服咨询，<span style="font-weight: bold; color: #E3E3E3;">确认无误后再进行购买操作</span>。</p>
                    <p>3.3 您购买模型素材前，请仔细阅读商品描述中的文件格式、软件版本、渲染器及插件等信息。平台仅针对<span style="font-weight: bold; color: #E3E3E3;">平台服务器原因导致的下载失败、附件无法下载</span>的情况提供技术协助，<span style="font-weight: bold; color: #E3E3E3;">不提供退款服务</span>，其余因商品内容产生的疑问请在购买前确认。</p>
                    <p>3.4 <span style="font-weight: bold; color: #E3E3E3;">模型素材一经购买，无任何退款情形，所有情况均不支持退款</span>，包括但不限于：</p>
                    <p>（1） 使用与描述要求不符的软件、软件版本或运行环境打开文件，导致错误；</p>
                    <p>（2） 格式转换错误或软件不兼容、自行修改模型导致素材无法正常使用；</p>
                    <p>（3） 用户不会使用相关软件，导致素材无法正常使用；</p>
                    <p>（4） 所购模型与描述内容相符但用户主观不满意；</p>
                    <p>（5） 由于电脑硬件配置不足，导致文件无法正常打开，或打开后运行卡顿；</p>
                    <p>（6）轻微参数误差：例如面数、贴图精度等差异＜10%；</p>
                    <p>（7）压缩包缺少部分分卷，导致无法解压，或解压后的文件与描述内容不一致；</p>
                    <p>（8）所购素材与预览图或描述内容不符。</p>
                    <p>3.5 附件中的 obj、fbx 等通用格式，导入三维软件或引擎中均无法直接达到原始文件中展示的渲染效果，需要手动进行二次调整。详情请仔细阅读《通用格式购前帮助文档》，<span style="font-weight: bold; color: #E3E3E3;">该类操作问题不构成退款理由</span>。</p>
                    <p>3.6 投诉程序：仅针对<span style="font-weight: bold; color: #E3E3E3;">平台服务器原因导致的下载失败、附件无法下载</span>的情况，可于下载后 24 小时内，在你的后台 - 交易，相应的作品下点击【申请售后】申请技术协助。逾期未申请的，资金提现到卖家帐号，交易完成，网站将不再受理相关技术协助申请。接到售后申请后，管理员将尽快核实，如情况属实，将为您提供技术协助解决下载问题，<span style="font-weight: bold; color: #E3E3E3;">不提供退款处理</span>。</p>
                    <p>3.7 作品及 / 或服务的浏览、收藏</p>
                    <p>在您浏览我们网站的过程中，我们为您提供了信息分类、关键词检索、筛选、收藏及关注等功能，以更好地匹配您的需求。您可以对您感兴趣的作品及 / 或服务进行收藏、添加至购物车，关注您所感兴趣的创作者等，<span style="font-weight: bold; color: #E3E3E3;">方便您充分了解商品后再决定是否购买</span>。
                    </p>
                    <p>3.8 作品的购买与评价</p>
                    <p>当您在我们平台向出售者购买作品时，请您务必仔细确认所购作品的内容、授权范围等重要事项，<span style="font-weight: bold; color: #E3E3E3;">因购买前未确认清楚导致的任何问题，由用户自行承担，且不支持退款</span>。您应当注意，除有特殊示明情况外，一般情况下，出售者出售的是对作品的欣赏、学习的使用权，不包括任何商用或衍生开发的授权。
                    </p>
                    <p>您的购买行为应当基于真实的消费需求，不得存在对作品及 / 或服务实施恶意购买、恶意维权等扰乱我们平台正常交易秩序的行为。基于维护我们平台交易秩序及交易安全的需要，我们发现上述情形时可主动执行关闭相关交易订单等操作，<span style="font-weight: bold; color: #E3E3E3;">且已支付款项不予退还</span>。
                    </p>
                    <p>您有权在我们平台提供的评价系统中对与您达成交易的其他用户作品进行评价。您应当理解，您在我们平台的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，您有权选择通过匿名形式发表评价内容。
                    </p>
                    <p>为确保评价内容能为其他用户购买决策提供可靠的依据，反映作品的真实情况，您的所有评价行为应遵守我们平台规则的相关规定，评价内容应当合法、客观、真实，与交易的作品具有关联性，且不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息。
                    </p>
                </div>

                <!-- 四、作品用途 -->
                <div class="protocol-section">
                    <h2>四、作品用途</h2>
                    <p>4.1您在购买的作品（原创作品或授权作品）仅限您在授权书中明确的被授权方使用，作品权利人（作品原创者或取得原创作品合法授权的人）授权被授权方非独占性的使用其作品，被授权方须在智步云上模型网的相关规定、授权规则和作品权利人授权的范围内和 / 或项目中使用，且不得转授权给其他任何第三方使用，也不得超出授权范围和 / 或项目使用。<span style="font-weight: bold; color: #E3E3E3;">因超出授权范围使用导致的任何问题，由用户自行承担，且已支付的购买款项不予退还</span>。
                    </p>
                    <p>4.2您不得将购买作品的电子档源文件再出售、转让、发布、供他人下载或以其他方式供他人使用。您一旦确认购买将扣除相关费用，<span style="font-weight: bold; color: #E3E3E3;">无论任何原因导致的购买错误，费用均不予退还</span>。</p>
                    <p>4.3您不得将通过智步云上模型网获取的作品使用在任何违法、色情场合，包括但不限于违法宣传品、违法的医疗保健宣传品、色情淫秽的出版物等，用户不得侵害智步云上模型网、作品权利人的合法权益。违规使用原创作品和授权作品的，您将自行承担一切因此造成的经济损失和法律后果，<span style="font-weight: bold; color: #E3E3E3;">且已支付的购买款项不予退还</span>。
                    </p>
                    <p>4.4 商业授权使用必须遵守《智步云上 模型网模型授权协议》，点击跳转查看相关协议。<span style="font-weight: bold; color: #E3E3E3;">因未遵守授权协议导致的任何问题，由用户自行承担，且已支付的购买款项不予退还</span>。</p>
                </div>

                <!-- 五、代收、代付款 -->
                <div class="protocol-section">
                    <h2>五、代收、代付款</h2>
                    <p>5.1 智步云上模型网对您在作品交易的款项提供代收款服务。<span style="font-weight: bold; color: #E3E3E3;">模型素材一经购买，所支付款项不予退还，平台将按约定将款项结算至卖家账户</span>。
                    </p>
                    <p>5.2 智步云上模型网向您提供交易款代收代付服务，其中包含：</p>
                    <p>（1）代管：代为保管您在智步云上模型网账户的充值。
                    </p>
                    <p>（2）代收：代为收取其他智步云上模型网用户向您支付的各类款项。</p>
                    <p>（3）代付：代为将您交付代管或代收的款项支付给您指定的其他智步云上模型网用户。您同意并知晓：智步云上模型网代付后，非经法律程序或者非依本协议之约定，该支付不可逆转；<span style="font-weight: bold; color: #E3E3E3;">因模型购买产生的款项，完成支付后即触发代付流程，无退款情形</span>。
                    </p>
                    <p>（4）查询：您可以在智步云上模型网中查询您智步云上模型网账户名下的交易记录，若认为记录有误的，您可以要求智步云上模型网提供管理后台有关收付款的详细记录。但您理解并同意：最终收到款项的服务由您提供的有效账户对应的服务公司（如支付宝账户对应的公司）或者银行等金融机构提供的，如与网站记录不符，请向其进行核实查证。
                    </p>
                    <p>5.3为保障您交易时的合法权益，您理解并同意接受以下规则：</p>
                    <p>（1）您通过智步云上模型网预设的交易流程进行交易时，智步云上模型网会根据您的指示代收、代付款项，上述指示不可撤回或撤销；<span style="font-weight: bold; color: #E3E3E3;">模型购买的支付指令一经发出并完成，款项不予退还</span>。</p>
                    <p>（2）<span style="font-weight: bold; color: #E3E3E3;">仅因平台系统故障导致的交易未成功生成订单的情况</span>，智步云上模型网会及时将此次操作的金额返还给您。但受限于银行或支付平台的规定，智步云上模型网不对返还到账时间做出承诺；<span style="font-weight: bold; color: #E3E3E3;">模型订单生成后，无论任何原因均不退款</span>。</p>
                    <p>（3）充值的金额不能提现，亦不能在不同的账号之间转移。仅允许在智步云上模型网进行消费使用。平台倡导理性消费、量入为出。请务必根据您的自身消费能力和实际需求，合理充值、购买，避免过度消费。</p>
                    <p>由于当下网络诈骗手段层出不穷，部分不法分子利用平台充值提现机制进行欺诈活动，严重损害广大用户的利益。为防范此类风险，平台经慎重考虑，规定充值金额仅用于平台内消费，无法提现。</p>
                    <p>我们深知这一规则可能给您带来不便，但保障资金安全是平台的首要职责。平台致力于为您提供丰富优质的产品与服务，让充值金额在平台内充分发挥价值。若您有任何疑问或建议，欢迎随时联系客服，我们将竭诚为您服务。
                    </p>
                    <p>5.4因自身过错导致的账户任何损失由您自行承担，该过错包括但不限于：不按照交易提示操作，未及时进行交易操作，遗忘或泄漏密码，密码被他人破解，计算机被他人侵入等。<span style="font-weight: bold; color: #E3E3E3;">因自身过错导致的错误购买，所支付款项不予退还</span>。</p>
                    <p>5.5 智步云上模型网并非银行或其它金融机构，智步云上模型网代管、代收或代付的款项不产生任何利息及其他收益。</p>
                    <p>5.6您不得将交易用于任何非法目的，同时也不得以任何非法方式在智步云上模型网进行交易，不得有侵害他人合法权益之行为，包括但不限于：冒用他人名义及非法使用他人支付宝账户进行交易的，从事任何可能含有电脑病毒或可能侵害本服务系统的行为，其他不适当行为。一经发现，平台将冻结账户并终止服务，<span style="font-weight: bold; color: #E3E3E3;">相关交易款项不予退还</span>。
                    </p>
                    <p>5.7 智步云上模型网在发现异常交易或有违反法律规定、本协议约定时，有权不经通知先行对您智步云上模型网账户下的正在交易的作品采取暂停、取消交易或冻结账户等限制措施，由此造成的损失，智步云上模型网不承担任何赔偿责任，<span style="font-weight: bold; color: #E3E3E3;">已完成支付的款项不予退还</span>。
                    </p>
                </div>

                <!-- 六、服务的变更、中断或终止 -->
                <div class="protocol-section">
                    <h2>六、服务的变更、中断或终止</h2>
                    <p>6.1鉴于网络服务的特殊性，您同意智步云上模型网可自行决定在发出通知或不发出通知的情况下，随时变更、中断或终止部分或全部的网络服务。服务终止后，智步云上模型网没有义务为您保留原账户或与之相关的任何信息。当智步云上模型网变更、中断或终止全部网络服务时，智步云上模型网不提供赔偿、退款服务；<span style="font-weight: bold; color: #E3E3E3;">服务变更、中断仅影响未完成的交易，已完成购买的模型，不予退款</span>。
                    </p>
                    <p>6.2 智步云上模型网需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，智步云上模型网无需为此承担任何责任，但智步云上模型网应尽可能事先通告。<span style="font-weight: bold; color: #E3E3E3;">检修维护期间导致的下载问题，平台将在恢复后提供技术协助，不提供退款服务</span>。
                    </p>
                </div>

                <!-- 七、知识产权 -->
                <div class="protocol-section">
                    <h2>七、知识产权</h2>
                    <p>7.1 智步云上模型网及智步云上模型网所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的布局、网页设计、经由智步云上模型网或广告商向您呈现的广告或资讯，均由智步云上模型网或其它权利人依法享有相应的知识产权及其他权利，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经智步云上模型网或权利人书面明示授权，您不得以包括但不限于修改、出租、出借、出售、散布等方式使用智步云上模型网及智步云上模型网所使用的上述任何作品和资源，或根据上述作品和资源制作成任何种类产品。<span style="font-weight: bold; color: #E3E3E3;">如违反本条款，平台将终止服务，且已支付的模型购买款项不予退还</span>。
                    </p>
                    <p>7.2您在任何情况下都不要私自使用我们的包括但不限于我们的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（统称为 “标识”）。未经我们事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用我们上述商标、标识等给我们或他人造成损失的，由您承担全部法律责任，<span style="font-weight: bold; color: #E3E3E3;">且已支付的模型购买款项不予退还</span>。
                    </p>
                    <p>7.3您不得经由非智步云上模型网所提供的界面使用智步云上模型网，不得在除智步云上模型网以外的网站上对智步云上模型网建立镜像。<span style="font-weight: bold; color: #E3E3E3;">如违反本条款，平台将终止服务，且已支付的模型购买款项不予退还</span>。</p>
                    <p>7.4原创作品权属归著作权人本人所有，受相关法律保护。购买方购买作品的，将根据该作品具体的授权许可方式取得相应的授权，购买方下载、使用作品应在授权范围内和 / 或项目中使用。且您在智步云上模型网所销售的视频作品均不包含该作品为展示效果所添加的音频、字体文件，该视频作品的授权亦不包括对视频所附带音频、字体文件的使用，经您特别授权的除外。<span style="font-weight: bold; color: #E3E3E3;">因未遵守权属及授权约定导致的任何问题，由用户自行承担，且已支付的购买款项不予退还</span>。
                    </p>
                    <p>7.5我们仅向您提供平台服务，您了解平台上的信息系用户自行发布，且可能存在风险和瑕疵。我们将通过依法建立相关检查监控制度尽可能保障您在我们平台上的合法权益及良好体验。同时，鉴于我们平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，我们无法逐一审查作品的信息，无法逐一审查交易所涉及的作品的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断，<span style="font-weight: bold; color: #E3E3E3;">因判断失误导致的购买行为，所支付款项不予退还</span>。
                    </p>
                </div>

                <!-- 八、通知送达 -->
                <div class="protocol-section">
                    <h2>八、通知送达</h2>
                    <p>8.1本协议项下，智步云上模型网对于您所有的通知均可通过网页公告、智步云上模型网站内短信、电子邮件、手机短信或常规的信件传送等方式中的任何一种进行，且均于发送成功之时视为已送达收件人。<span style="font-weight: bold; color: #E3E3E3;">有关模型购买不退款的规则变更、补充通知，将通过上述方式送达，一经送达即生效</span>。</p>
                    <p>8.2您对于智步云上模型网的通知应当通过智步云上模型网对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。
                    </p>
                </div>

                <!-- 九、保密 -->
                <div class="protocol-section">
                    <h2>九、保密</h2>
                    <p>对讨论、签订、执行本协议中所获悉的属于对方的、且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的提供方同意，不得向第三方泄露该文件资料的全部或者部分内容。但法律、法规、规章另有规定或者双方另有约定的除外。<span style="font-weight: bold; color: #E3E3E3;">如违反保密条款，给对方造成损失的，需承担赔偿责任，且已支付的模型购买款项不予退还</span>。
                    </p>
                </div>

                <!-- 十、法律适用与争议解决 -->
                <div class="protocol-section">
                    <h2>十、法律适用与争议解决</h2>
                    <p>10.1本协议及其规则的有效性、履行及争议解决等所有事宜，均适用中华人民共和国法律法规及相关规定。<span style="font-weight: bold; color: #E3E3E3;">因模型购买不退款产生的争议，亦按本条款处理</span>。
                    </p>
                    <p>10.2就本协议及协议所附规则的内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均应向北京智步云上科技有限公司所在地人民法院提起诉讼。</p>
                    <p>10.3 智步云上模型网有权决定是否参与调处用户之间因作品交易或作品定制产生的争议。<span style="font-weight: bold; color: #E3E3E3;">调处结果不涉及退款，仅针对交易流程中的技术问题提供解决方案</span>。</p>
                </div>

                <!-- 十一、附则 -->
                <div class="protocol-section">
                    <h2>十一、附则</h2>
                    <p>11.1根据本协议制定的各项服务的实施细则以及其他以智步云上模型网名义发布的制度、办法、规定、公告等均属本协议不可分割的部分，<span style="font-weight: bold; color: #E3E3E3;">其中有关模型购买不退款的补充规定，与本协议具有同等法律效力</span>。</p>
                    <p>11.2本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。
                    </p>
                    <p>11.3您和我们均是独立的主体，在任何情况下本协议不构成我们对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。<span style="font-weight: bold; color: #E3E3E3;">本协议未作明示约定的，均不构成平台对用户的退款承诺</span>。
                    </p>
                    <p>11.4本协议项下的 “您” 是指与智步云上模型网签订《智步云上模型网服务协议》并完成注册流程的用户。</p>
                    <p>11.5本协议适用所有在智步云上模型网注册的进行交易的用户，<span style="font-weight: bold; color: #E3E3E3;">所有用户的模型购买行为，均受本协议中不退款规则的约束</span>。
                    </p>
                    <p>11.6本协议的最终解释权归北京智步云上科技有限公司所有。<span style="font-weight: bold; color: #E3E3E3;">对于本协议中模型购买不退款规则的解释，亦由北京智步云上科技有限公司作出最终解释</span>。
                    </p>
                </div>
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>